export const InvoicesPermissions = {
  ViewAndSearchInMainAccountsInvoicesPage:
  {
    permissionsId: 'ed12ab95-4ebe-4cb4-c9d7-08d94f66fc61',
    permissionsName: 'View and Search in main Accounts Invoices page',
    componentsId: null,
    components: null
  },
  AddNewReceipt:
  {
    permissionsId: '84079d17-6d11-4232-7ca2-08d9686ecc35',
    permissionsName: 'Add New Receipt',
    componentsId: null,
    components: null
  }
};
